import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  effect,
} from '@angular/core';
import { IonicModule, NavController, MenuController } from '@ionic/angular';
import { MenuItem, MenuLink } from './vertical-header';
import { ToolsService } from 'src/app/services/tools.service';
import { Router } from '@angular/router';
import { DashboardService } from 'src/app/services/dashboard.service';
import { UserService } from 'src/app/services/user.service';
import {BreakpointObserver, Breakpoints, LayoutModule} from '@angular/cdk/layout';
import { BillsServiceService } from 'src/app/services/bills-service.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-vertical-header',
  templateUrl: './vertical-header.component.html',
  styleUrls: ['./vertical-header.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, LayoutModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class VerticalHeaderComponent implements OnInit, AfterViewInit {
  @Input() menuItems: MenuItem[] = [];
  @Output() isDenseEvent = new EventEmitter<boolean>();
  isDense: boolean = true;
  selectedItem: string = 'project';
  openSubMenus: { [key: string]: boolean } = {};
  sidebarStyle: any = {};
  isExpanded: boolean = true;
  showMenu: boolean = true;
  @ViewChild('sidebar') sidebarElement!: ElementRef;
  reportsList: any;
  isMobile: boolean = false;

  pendingApprovedBillsCount: any = 0;
  isNavigating: boolean = false;

  constructor(
    private toolService: ToolsService,
    private router: Router,
    private dashBoardService: DashboardService,
    private navCtrl: NavController,
    public authService: UserService,
    private breakpointObserver: BreakpointObserver,
    private menuCtrl:  MenuController,
    public billService: BillsServiceService,
    private storageService: StorageService
  ) {

    toolService.isMenuFixed$.subscribe((isFixed)  => {
      this.isExpanded = isFixed;
      if(!this.isExpanded){

      }
      this.isDense = this.isExpanded;
      this.setIsDense(this.isExpanded)

    })


    effect(() => {
      this.billService.refreshTrigger();
      this.getPendingBills();
    });

  }
  ngAfterViewInit(): void {
    // this.sidebarElement.nativeElement.addEventListener(
    //   'transitionend',
    //   this.handleTransitionEnd.bind(this)
    // );
  }

  async ngOnInit() {
    this.menuItems.forEach((menuItem) => {
      menuItem.links.forEach((link) => {
        if (link.subMenu) {
          this.openSubMenus[link.id] = false;
        }
      });
    });

    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
      .subscribe(result => {
        if (result.matches) {
          this.isMobile = true;
          this.toolService.setMenuFixed(false)
        }
      });

      await this.getPendingBills();
  }

  async goTo2(url?: string, id?: string) {
    if (this.isNavigating) {
      return;
    }

    if (!url && !id) {
      return;
    }

    this.isNavigating = true;

    try {
      if (id) {
        this.selectedItem = id;
      }

      if (id && id.startsWith('report-') && this.reportsList) {
        const reportId = parseInt(id.split('-')[1], 10);
        const report = this.reportsList.find(
          (report: any) => report.id === reportId
        );

        if (report) {
          await this.goToReportDetails(report);

          if (this.isMobile) {
            await this.menuCtrl.close('first');
          }

          return;
        }
      }

      if (url) {
        const navigated = await this.navCtrl.navigateRoot(url, {
          animated: true
        });

        if (!navigated) {
          console.warn('navigateroot no pudo completar la navegacion');

          await this.router.navigateByUrl(url, {
            replaceUrl: true
          });
        }

        if (this.isMobile) {
          await this.menuCtrl.close('first');
        }
      }

    } catch (error) {
      console.error('Navigation error:', error);

      if (url && this.router.url !== url) {
        try {
          await this.router.navigateByUrl(url, {
            replaceUrl: true
          });
        } catch (retryError) {
          console.error('Retry navigation error:', retryError);
        }
      }

    } finally {
      this.isNavigating = false;
    }
  }


  goTo(url?: string, id?: string) {

    if (url) {
      this.navCtrl.navigateRoot(url);
      this.isMobile && this.menuCtrl.close('first');
    }
  }

  handleTransitionEnd(event: TransitionEvent): void {
    if (event.propertyName === 'width') {
      if (this.isDense) {
        this.sidebarStyle = 'hidden';
      } else {
        this.sidebarStyle = 'auto';
      }
    }
  }

  setIsDense(isDense: boolean) {
    this.toolService.setOpenMenu(isDense);
  }

  async toggleSubMenu(id: string) {
    if (id == 'reports' && !this.reportsList) {
      await this.getReportsList()
    }
    this.openSubMenus[id] = !this.openSubMenus[id];

  }

  async getReportsList() {
    this.reportsList = await this.dashBoardService.getDashBoards();
    this.reportsList.sort((a: { name: string }, b: { name: string }) =>
      a.name.localeCompare(b.name)
    );

    // console.log("this.reportsList", this.reportsList);

    const reportsMenuItem = this.menuItems.find(item => item.id === 'admin');
    if (reportsMenuItem) {
      const reportsLink = reportsMenuItem.links.find(link => link.id === 'reports');
      if (reportsLink) {
        reportsLink.subMenu = this.reportsList.map((report: { id: any; name: any; url: any; }) => ({
          id: `report-${report.id}`,
          name: report.name,
          icon: 'trending-up-outline',
          url: report.url,
        }));
      }
    }
  }

  async goToReportDetails(report: any) {
    console.debug("goToReportDetails", report);

    try {
      await this.router.navigate(['/report-details/' + report.id], {
        state: {
          report: report,
        },
      });
    } catch (error) {
      console.error("Error navegando al reporte:", error);
    } finally {
      setTimeout(() => this.isNavigating = false, 300);
    }
  }

  isSubMenuOpen(id: string): boolean {
    return !!this.openSubMenus[id];
  }

  mouseEnter() {
    if (this.isExpanded) {
      this.isDense = false;
      this.setIsDense(false);
    }
  }

  mouseLeave() {
    if (this.isExpanded) {
      this.isDense = true;
      this.setIsDense(true);
    }
  }

  showOptionMenu(link: MenuLink){
    if(link && link.permissions) {
      return link && link.permissions?.some((permission: any) => this.authService.hasPermission(permission))
    }else{
      return true;
    }

  }

  isMenuItemVisible(menuItem: MenuItem): boolean {
    return menuItem.links.some(link => this.showOptionMenu(link));
  }

  async getPendingBills() {
    try {
      const response: any = await this.billService.getBillsPending({
        customer: this.storageService.getSelectedMall().id,
      });

      this.pendingApprovedBillsCount = response.pending_count

      this.billService.setCount(response.pending_count);

    } catch (error) {
      console.error('error obteniendo contador', error);
    }
  }
}
